import InsuranceCard from "./InsuranceCard";

export default function InsuranceGrid({ 
  items, 
  currentPage, 
  total, 
  perPage, 
  onPrev, 
  onNext, 
  onGo,
  showCompareOption = false,
  selectedPolicies = [],
  onToggleSelect 
}) {
  const totalPages = Math.max(1, Math.ceil(total / perPage));
  
  const isSelected = (item) => {
    return selectedPolicies.some(p => p.id === item.id);
  };
  
  return (
    <div className="mt-6">
      <div className="grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4">
        {items.map((item) => (
          <div key={item.id} data-card-item data-id={item.id} className="h-full cursor-pointer">
            <InsuranceCard 
              item={item} 
              showCompareOption={showCompareOption}
              isSelected={isSelected(item)}
              onToggleSelect={onToggleSelect}
            />
          </div>
        ))}
      </div>

      <div className="flex flex-col gap-3 justify-between items-center mt-8 sm:flex-row">
        <p className="text-sm text-gray-600">
          Showing {(currentPage - 1) * perPage + 1}
          –{Math.min(currentPage * perPage, total)} of {total}
        </p>
        <div className="flex gap-2 items-center">
          <button
            onClick={onPrev}
            className="px-3 py-2 text-sm bg-white rounded-lg border border-gray-200 hover:bg-gray-50 disabled:opacity-50"
            disabled={currentPage === 1}
          >
            Prev
          </button>
          {Array.from({ length: totalPages }).map((_, i) => (
            <button
              key={i}
              onClick={() => onGo(i + 1)}
              className={`w-9 h-9 rounded-lg text-sm font-medium border ${
                currentPage === i + 1
                  ? "bg-emerald-500 text-white border-emerald-500"
                  : "bg-white text-gray-700 border-gray-200 hover:bg-gray-50"
              }`}
            >
              {i + 1}
            </button>
          ))}
          <button
            onClick={onNext}
            className="px-3 py-2 text-sm bg-white rounded-lg border border-gray-200 hover:bg-gray-50 disabled:opacity-50"
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}


